"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../other/helpers");
// tslint:disable:max-line-length
/**
 * @hidden
 */
var WebRequester = /** @class */ (function () {
    /**
     * @hidden
     */
    function WebRequester(options) {
        /**
         * @hidden
         */
        this.settings = this.getInitialSettings();
        this.instance = this.createInstance();
        this.setSettings(this.getInitialSettings());
        if (options) {
            this.setOptions(options);
        }
    }
    /**
     * @hidden
     */
    WebRequester.prototype.get = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.instance
                                .get(url)
                                .then(function (res) { return _this.convertToAttensiAPIResponse(res); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _a.sent();
                        throw this.convertToAttensiAPIError({
                            response: error_1.response,
                            originalError: new Error(),
                            method: 'GET',
                            url: url,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     */
    WebRequester.prototype.getWithQuery = function (url, query) {
        return __awaiter(this, void 0, void 0, function () {
            var queryString, response, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryString = helpers_1.buildQueryString(query);
                        return [4 /*yield*/, this.instance
                                .get(url + queryString)
                                .then(function (res) { return _this.convertToAttensiAPIResponse(res); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_2 = _a.sent();
                        throw this.convertToAttensiAPIError({
                            response: error_2.response,
                            originalError: new Error(),
                            method: 'GET',
                            url: url,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     */
    WebRequester.prototype.post = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.instance
                                .post(url)
                                .then(function (res) { return _this.convertToAttensiAPIResponse(res); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_3 = _a.sent();
                        throw this.convertToAttensiAPIError({
                            response: error_3.response,
                            originalError: new Error(),
                            method: 'POST',
                            url: url,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     */
    WebRequester.prototype.postWithBody = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.instance
                                .post(url, body)
                                .then(function (res) { return _this.convertToAttensiAPIResponse(res); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_4 = _a.sent();
                        throw this.convertToAttensiAPIError({
                            response: error_4.response,
                            originalError: new Error(),
                            method: 'POST',
                            url: url,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     */
    WebRequester.prototype.patchWithBody = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.instance
                                .patch(url, body)
                                .then(function (res) { return _this.convertToAttensiAPIResponse(res); })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_5 = _a.sent();
                        throw this.convertToAttensiAPIError({
                            response: error_5.response,
                            originalError: new Error(),
                            method: 'PATCH',
                            url: url,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @hidden
     */
    WebRequester.prototype.convertToAttensiAPIResponse = function (axiosResponse) {
        return {
            status: axiosResponse.status,
            statusText: axiosResponse.statusText,
            data: axiosResponse.data,
        };
    };
    WebRequester.prototype.convertToAttensiAPIError = function (config) {
        var response = this.convertToAttensiAPIResponse(config.response);
        var error = config.originalError;
        error.status = response.status;
        error.data = response.data;
        if (config.response.message) {
            error.statusText = config.response.message;
        }
        else {
            error.statusText = response.statusText;
        }
        error.message = config.method + " to " + config.url + " failed with status " + error.status + ", " + error.statusText;
        return error;
    };
    return WebRequester;
}());
exports.WebRequester = WebRequester;
//# sourceMappingURL=webRequester.js.map